import { render, staticRenderFns } from "./KnProductUOM.vue?vue&type=template&id=67580c7a"
import script from "./KnProductUOM.js?vue&type=script&lang=js&external"
export * from "./KnProductUOM.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports